module.exports = __webpack_public_path__ + "static/img/skull.f48f6cfd.svg";